import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as actions from "../actions";
import ApplicationOverview from "../components/applicationOverview/applicationOverview";
import Breadcrumb from "../components/breadcrumb/breadcrumb";
import withTracker from "./withtracker";
import AuthorizationHOC from "./AuthorizationHOC";
import { REGISTERED_USERS } from "../constants/userGroups";
import withBreadCrumb from "./withBreadcrumb";
import { parseApplicationFromState } from "../constants/parse/application";

import queryString from "query-string";
import { parseOrganization } from "../constants/parse/organization";
import { getRouteUrl } from "../routers";
import { isEmpty } from "lodash";
import { ROUTE_APPLICATION_VIEW } from "../routers/content/application";
import { ROUTE_ORGANIZATION_VIEW_SINGLE } from "../routers/content/organization";
import ApplicationEditSubscriptions from "../components/applicationEditSubscriptions/applicationEditSubscriptions";
import AnalyticsOverview from "../components/analytics/analyticsOverview";

function ApplicationHOC(props) {
  const {
    organizations,
    location,
    breadcrumb,
    loading,
    application,
    unsubscribeFromApiProductModalIsOpen,
    openUnsubscribeFromApiProductModal,
    closeUnsubscribeFromApiProductModal,
    unsubscribedFromApiProductSuccessfully,
    resetApplicationClientSecret,
    fetchApplication,
    errorMessage,
  } = props;
  const { applicationId } = props.match.params;

  const { organization } = queryString.parse(location.search);

  const [clientSecretVisible, setClientSecretVisible] = useState(false);

  useEffect(() => {
    fetchApplication({ applicationId, organizationId: organization });
  }, [applicationId, organization]);

  useEffect(() => {
    fetchApplication({ applicationId, organizationId: organization });
  }, [unsubscribedFromApiProductSuccessfully]);

  const applicationData = parseApplicationFromState(application, applicationId);

  // Show-once secret: the Core returns the client secret right after create / go-live / reset and
  // we immediately ask it to forget it (delete-secret). Later fetches (Application/list, /get) then
  // come back without it and would wipe it from the store within a second, before the user can
  // copy it. Keep the revealed value in component state for as long as this page is mounted; a
  // reload or navigation away drops it, which is the intended "visible once" behaviour.
  const [revealedSecret, setRevealedSecret] = useState(null);

  useEffect(() => {
    if (
      !isEmpty(applicationData.clientSecret) &&
      !isEmpty(applicationData.uuid)
    ) {
      setRevealedSecret(applicationData.clientSecret);
      props.deleteApplicationSecret(applicationData.uuid);
    }
  }, [applicationData.clientSecret, applicationData.uuid]);

  useEffect(() => {
    setRevealedSecret(null);
  }, [applicationId]);

  const applicationView = revealedSecret
    ? { ...applicationData, clientSecret: revealedSecret }
    : applicationData;

  const organizationData = parseOrganization(
    props.organizations && props.organizations[organization]
  );

  const applicationUrl = getRouteUrl(
    ROUTE_APPLICATION_VIEW,
    { applicationId: applicationData.uuid },
    { organization }
  );

  const organizationUrl = getRouteUrl(ROUTE_ORGANIZATION_VIEW_SINGLE, {
    organizationId: organization,
  });
  return (
    <div>
      {applicationData.title && organizationData && organizationData.title && (
        <Breadcrumb
          {...breadcrumb}
          params={{
            app: {
              name: applicationData.title,
              href: applicationData.uuid ? applicationUrl : null,
            },
            org: {
              href: organizationUrl,
              name: organizationData.title,
            },
          }}
        />
      )}
      <ApplicationOverview
        application={applicationView}
        organizationUuid={organization}
        openUnsubscribeFromApiProductModal={openUnsubscribeFromApiProductModal}
        unsubscribedFromApiProductSuccessfully={
          unsubscribedFromApiProductSuccessfully
        }
        clientSecretVisible={clientSecretVisible}
        toggleClientSecretVisibility={() =>
          setClientSecretVisible(!clientSecretVisible)
        }
        resetApplicationClientSecret={resetApplicationClientSecret}
        loading={loading}
        closeUnsubscribeFromApiProductModal={
          closeUnsubscribeFromApiProductModal
        }
        errorMessage={errorMessage}
      />

      <ApplicationEditSubscriptions
        openUnsubscribeFromApiProductModal={openUnsubscribeFromApiProductModal}
        closeUnsubscribeFromApiProductModal={
          closeUnsubscribeFromApiProductModal
        }
        unsubscribeFromApiProductModalIsOpen={
          unsubscribeFromApiProductModalIsOpen
        }
        applicationId={applicationData.uuid}
        subscriptions={applicationData.subscriptions || []}
        applicationStatus={applicationData.applicationStatus || "DEVELOPMENT"}
      />

      {applicationData.uuid && (
        <AnalyticsOverview
          applicationId={applicationData?.clientId.production}
          applicationStatus={applicationData?.applicationStatus}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  organizations: state.organizationReducer.byId,
  loading: state.application.loading,
  application: state.application,
  unsubscribeFromApiProductModalIsOpen:
    state.application.unsubscribeFromApiProductModalIsOpen,
  unsubscribedFromApiProductSuccessfully:
    state.application.unsubscribedFromApiProductSuccessfully,
  errorMessage: state.application.errorMessage,
});

const mapDispatchToProps = (dispatch) => ({
  fetchOrganizations: (payload) => {
    dispatch(actions.fetchOrganizations(payload));
  },
  fetchApplication: (payload) => {
    dispatch(actions.fetchApplication(payload));
  },
  openDeleteApplicationModal: () => {
    dispatch(actions.openDeleteApplicationModal());
  },
  closeDeleteApplicationModal: () => {
    dispatch(actions.closeDeleteApplicationModal());
  },
  openUnsubscribeFromApiProductModal: (payload) => {
    dispatch(actions.openUnsubscribeFromApiProductModal(payload));
  },
  closeUnsubscribeFromApiProductModal: () => {
    dispatch(actions.closeUnsubscribeFromApiProductModal());
  },
  resetApplicationClientSecret: (payload) => {
    dispatch(actions.resetApplicationClientSecret(payload));
  },
  deleteApplicationSecret: (payload) => {
    dispatch(actions.deleteApplicationClientSecret(payload));
  },
});

export default withTracker(
  AuthorizationHOC(REGISTERED_USERS)(
    withBreadCrumb(
      connect(mapStateToProps, mapDispatchToProps)(ApplicationHOC),
      {
        name: "{app}",
        parents: ["Organizations", "{org}"],
      }
    )
  )
);
